import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export { isMediaClientError, getMediaClientErrorReason } from './helpers';

/**
 * Base class for media errors
 */
export var BaseMediaClientError = /*#__PURE__*/function (_Error) {
  function BaseMediaClientError(reason, metadata, innerError) {
    var _this;
    _classCallCheck(this, BaseMediaClientError);
    _this = _callSuper(this, BaseMediaClientError, [reason]);

    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    _this.reason = reason;
    _this.metadata = metadata;
    _this.innerError = innerError;
    Object.setPrototypeOf(_this, (this instanceof BaseMediaClientError ? this.constructor : void 0).prototype);

    // https://v8.dev/docs/stack-trace-api
    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(_this, this instanceof BaseMediaClientError ? this.constructor : void 0);
    }
    return _this;
  }

  // TODO: Deprecate attributes getter https://product-fabric.atlassian.net/browse/CXP-4665
  _inherits(BaseMediaClientError, _Error);
  return _createClass(BaseMediaClientError);
}( /*#__PURE__*/_wrapNativeSuper(Error
// TODO: Deprecate attributes getter https://product-fabric.atlassian.net/browse/CXP-4665
));

// The only reason why this class exists is because BaseMediaClientError is abstract class, so it can't be used to deserialize ErrorFileState. We can refactor and simplify this later.
/** Generic Media Client Erorr. All errors extending BaseMediaClientError match CommonMediaClientError attributes. Used to deserialize ErrorFileState */
export var CommonMediaClientError = /*#__PURE__*/function (_BaseMediaClientError) {
  function CommonMediaClientError(reason, metadata, innerError) {
    _classCallCheck(this, CommonMediaClientError);
    return _callSuper(this, CommonMediaClientError, [reason, metadata, innerError]);
  }
  _inherits(CommonMediaClientError, _BaseMediaClientError);
  return _createClass(CommonMediaClientError, [{
    key: "attributes",
    get: function get() {
      return {
        reason: this.reason
      };
    }
  }]);
}(BaseMediaClientError);
export function isCommonMediaClientError(error) {
  if (!error) {
    return false;
  }
  // Check if the error is an instance of Error
  if (error instanceof CommonMediaClientError) {
    return true;
  }
  return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}

/** Deserializer ErrorFileState -> CommonMediaClientError */
export var toCommonMediaClientError = function toCommonMediaClientError(errorFileState) {
  var _errorFileState$detai;
  var error = (_errorFileState$detai = errorFileState.details) === null || _errorFileState$detai === void 0 ? void 0 : _errorFileState$detai.error;
  return new CommonMediaClientError((error === null || error === void 0 ? void 0 : error.reason) || 'unknown-reason', error.metadata, error.innerError);
};

/** Serializer CommonMediaClientError -> ErrorFileState */
export var fromCommonMediaClientError = function fromCommonMediaClientError(id, occurrenceKey, error) {
  return {
    status: 'error',
    id: id,
    occurrenceKey: occurrenceKey,
    reason: error.reason,
    details: _objectSpread({
      /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */
      error: {
        reason: error === null || error === void 0 ? void 0 : error.reason,
        metadata: error === null || error === void 0 ? void 0 : error.metadata,
        innerError: error === null || error === void 0 ? void 0 : error.innerError
      }
    }, error === null || error === void 0 ? void 0 : error.attributes),
    message: error === null || error === void 0 ? void 0 : error.message
  };
};